<template>
  <div class="board">
    <PageNavbar @open-preview="goToPreview"/>
    <BoardLeft/>
    <BoardMiddle/>
    <BoardRight v-if="!isMobile"/>

    <div class="board__mobile">
      <div class="board__modal">
        <BottomSheet 
          v-show="isMobile"
          v-model="isBottomSheetOpen"
          @opened="onOpen"
          @closed="onClose"
          :max-height="'100%'" 
        >
          <template #content>
            <div class="content__container">
              <BoardRight/>
            </div>
          </template>
        </BottomSheet>

      </div>

    </div>
  </div>

</template>

<script>
import PageNavbar from '@/components/UI/Sidebars/Navbar/PageNavbar.vue'
import BoardLeft from '@/components/pages/board/Floating/BoardLeft.vue'
import BoardMiddle from '@/components/pages/board/Floating/BoardMiddle.vue'
import BoardRight from '@/components/pages/board/Floating/BoardRight.vue'
import BottomSheet from '@/components/UI/Modal/BottomSheet.vue'

import { useRouter } from 'vue-router'

export default {
  components: { PageNavbar, BoardLeft, BoardMiddle, BoardRight, BottomSheet },
  data () {
    return {
      isBottomSheetOpen: false
    }
  },
  watch: {
    activeElement () {
      if(this.isMobile) this.isBottomSheetOpen = true
    }
  },
  computed: {
    activeElement() {
      return this.$store.getters['activeElement/activeElement'];
    },
    isMobile() {
      return this.$store.getters['device/isMobile'];
    }
  },
  mounted() {
  },
  methods: {
    onOpen() {
    },
    onClose() {
    },
    goToPreview() {
      this.$store.dispatch('activeElement/UPDATE_ACTIVE_ELEMENT', null);
      this.$router.push('/')
    }
  }
}
</script>


<style scoped>
.board__modal {
  position: fixed;
  left: 0;
  top: 0;
}
.content__container {
  padding-bottom: 5rem;
}
</style>